import type { Credito } from "../types/caja.types";
import {
  LS_CREDITOS,
  readAllCreditosFromStorage,
} from "./readCreditoFromStorage";

/**
 * Créditos guardados en almacenamiento local cuya `sesionId` coincide con la sesión cerrada.
 * Útil cuando el GET de caja aún no expone `creditosSesion` pero el ticket de cierre debe auditoría.
 */
export function readCreditosSnapshotForSesion(
  sesionId: string | null | undefined,
): Credito[] {
  if (!sesionId) return [];
  try {
    return readAllCreditosFromStorage().filter((f) => f.sesionId === sesionId);
  } catch {
    return [];
  }
}

export { LS_CREDITOS };
